import { makeStyles } from 'tss-react/mui';
import { link } from '../../styles/jss/utils';
import { colors, spacing } from '../../styles/jss/variables';
const MAX_WIDTH_INNER = 520;
const MAX_WIDTH_OUTER = 792;
const useStyles = makeStyles()((theme) => ({
    container: {
        maxWidth: MAX_WIDTH_OUTER,
        margin: `0 auto`,
        '& h2': Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.small_bold_lg),
        '& h4': Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.small_bold_lg),
        paddingBottom: spacing.xxl,
    },
    innerContainer: {
        maxWidth: MAX_WIDTH_INNER,
        margin: '0 auto',
    },
    box: {
        '& > form': { maxWidth: MAX_WIDTH_INNER, margin: `${spacing.medium} auto 0` },
        '& > p': { maxWidth: MAX_WIDTH_INNER },
        '&:last-child': { marginTop: spacing.small },
        [theme.breakpoints.up('sm')]: {
            border: `1px solid ${colors.supplementary.black}`,
            padding: spacing.xl,
        },
    },
    paragraph: Object.assign(Object.assign({}, theme.typography.medium_regular), { margin: '0 auto', [theme.breakpoints.up('sm')]: Object.assign(Object.assign({}, theme.typography.large_regular), { marginBottom: spacing.large }) }),
    link: Object.assign({}, link(theme.isFlyingFlowers ? undefined : colors.primary.gold4)),
    title: { marginBottom: spacing.small },
    alert: { marginBottom: spacing.large },
    emailSentText: {
        marginBottom: spacing.xxl,
        [theme.breakpoints.up('sm')]: {
            marginBottom: spacing.large,
        },
    },
}));
export default useStyles;
